"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../helpers/commonFunctions");
var PaymentInfoTable = /** @class */ (function (_super) {
    __extends(PaymentInfoTable, _super);
    function PaymentInfoTable(props) {
        var _this = _super.call(this, props) || this;
        _this.renderContents = function (items) {
            return items.map(function (item, index) { return ((0, jsx_runtime_1.jsxs)("tr", { children: [(0, jsx_runtime_1.jsx)("td", { children: item.cover }), (0, jsx_runtime_1.jsx)("td", { children: (0, commonFunctions_1.getAmountToDisplay)(item.premiumPrincipal) }), (0, jsx_runtime_1.jsx)("td", { children: (0, commonFunctions_1.getAmountToDisplay)(item.premiumIpt) }), (0, jsx_runtime_1.jsx)("td", { children: (0, commonFunctions_1.getAmountToDisplay)(item.interest) }), (0, jsx_runtime_1.jsx)("td", { children: (0, commonFunctions_1.getAmountToDisplay)(item.total) })] }, index)); });
        };
        return _this;
    }
    PaymentInfoTable.prototype.render = function () {
        if (this.props.loading) {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
        else {
            if (this.props.paymentInfo) {
                return ((0, jsx_runtime_1.jsx)("div", { className: "row mb-5", children: (0, jsx_runtime_1.jsxs)("div", { className: "table-responsive panel-border px-4", children: [(0, jsx_runtime_1.jsx)("b", { className: "pl-2", children: this.props.title }), (0, jsx_runtime_1.jsxs)("table", { className: "table table-hover table-sm table-bordered", children: [(0, jsx_runtime_1.jsx)("thead", { children: (0, jsx_runtime_1.jsxs)("tr", { className: "table-active", children: [(0, jsx_runtime_1.jsx)("th", { children: "Cover" }), (0, jsx_runtime_1.jsx)("th", { children: "Premium principal" }), (0, jsx_runtime_1.jsx)("th", { children: "IPT" }), (0, jsx_runtime_1.jsx)("th", { children: "Interest" }), (0, jsx_runtime_1.jsx)("th", { children: "Total" })] }) }), (0, jsx_runtime_1.jsx)("tbody", { children: this.renderContents(this.props.paymentInfo) })] })] }) }));
            }
            else {
                return (0, jsx_runtime_1.jsx)("h3", { className: "panel-border px-4", children: "N/A" });
            }
        }
    };
    PaymentInfoTable = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], PaymentInfoTable);
    return PaymentInfoTable;
}(React.Component));
exports.default = PaymentInfoTable;
//# sourceMappingURL=PaymentInfoTable.js.map